export class Secchi {
    Disparition: number;
    Reapparition: number;

    static mapFromJSON(json: any): Secchi {
        const s = new Secchi();
        
        s.Disparition = json.disparition;
        s.Reapparition = json.reapparition;

        return s;
    }
}